import React, { Fragment, useEffect } from 'react';
// import style from "./privacyPolicy.module.css"
import { Link } from 'react-router-dom';

export default function PrivacyPolicy() {

   useEffect(() => {
      // scroll to top when component mounts
      window.scrollTo({ top: 0, behavior: "smooth" });
   }, []);
   return (
      <Fragment>
         <div className='py-5 mb-4 container' >
            <h1 className='h3 fw-bold mt-5 text-center'>سياسة الخصوصية - سياسة الاسترجاع - الشروط والاحكام</h1>

            <div className="container mt-4" dir="rtl">
               <div className="card shadow-sm border-0">
                  <div className="card-body">
                     <h5 className="card-title fw-bold text-end"> 1. سياسة الخصوصية (Privacy Policy) ✅</h5>
                     <p className="card-text text-end">نحن نلتزم بحماية خصوصية مستخدمينا. عند استخدامك لموقعنا لحجز الخدمات  الطبية (مثل الأشعة والخدمات )، نقوم بجمع بعض البيانات الضرورية مثل: الاسم، رقم الهاتف، البريد الإلكتروني، والتقارير الطبية المطلوبة للحجز</p>

                     <h6 className="fw-semibold text-end mt-4">استخدام البيانات:</h6>
                     <p className="text-end">تُستخدم بياناتك فقط لإتمام عمليات الحجز والتنسيق مع مقدمي الخدمات  الطبية (المعامل – مراكز الأشعة – المستشفيات)، وإصدار خطاب التحويل المناسب.</p>

                     <h6 className="fw-semibold text-end mt-4">سرية المعلومات:</h6>
                     <p className="text-end">نحن نحافظ على سرية معلوماتك، ولا نشاركها مع أي جهة غير متعاقدة معنا، وتكون فقط لغرض تقديم الخدمة.</p>

                     <h6 className="fw-semibold text-end mt-4">حماية البيانات:</h6>
                     <p className="text-end mb-0">نستخدم وسائل أمان لحماية بياناتك من أي استخدام غير مصرح به.</p>
                  </div>
               </div>
            </div>


            <div className="container mt-5" dir="rtl">
               <div className="card shadow-sm border-0">
                  <div className="card-body">
                     <h5 className="card-title mb-3 fw-bold text-end">2. سياسة الاسترجاع والاستبدال (Refund & Exchange Policy)🔁  </h5>
                     <h5 className="card-subtitle mb-3 text-muted text-end">نظرًا لطبيعة الخدمات  الطبية المقدمة، نُطبق سياسة مرنة للاسترجاع في الحالات التالية:</h5>

                     <ul className="list-group list-group-flush text-end">
                        <li className="list-group-item">
                           يمكن استرداد المبلغ كاملاً قبل استخدام الخدمة أو قبل إصدار خطاب التحويل.
                        </li>
                        <li className="list-group-item">
                           لا يمكن استرجاع المبلغ بعد إصدار خطاب التحويل أو بدء تنفيذ الخدمة، إلا في حالة وجود خطأ من طرفنا.
                        </li>
                        <li className="list-group-item">
                           في حالة إلغاء الحجز من قِبل مقدم الخدمة، يحق للعميل استرداد المبلغ بالكامل أو إعادة جدولة الحجز مجانًا.
                        </li>
                     </ul>
                  </div>
               </div>
            </div>


            <div className="container mt-4" dir="rtl">
               <div className="card shadow-sm border-0">
                  <div className="card-body">

                     <h5 className="card-title mb-3 fw-bold text-end">3. سياسة الشحن أو التسليم (Shipping / Delivery Policy) 🚚 </h5>

                     <ul className="list-group list-group-flush text-end">
                        <li className="list-group-item">
                           لا يتم شحن منتجات مادية، ولكن:
                        </li>
                        <li className="list-group-item">
                           يتم إصدار خطاب تحويل إلكتروني بمجرد تأكيد الطلب والدفع.
                        </li>
                        <li className="list-group-item">
                           الخطاب يظهر في حساب المستخدم ويمكن تحميله وطباعته مباشرة.
                        </li>
                        <li className="list-group-item">
                           لا يُعتبر الحجز مؤكدًا إلا بعد الدفع الكامل واستلام خطاب التحويل.
                        </li>
                     </ul>

                  </div>
               </div>
            </div>


            <div className="container mt-4" dir="rtl">
               <div className="card shadow-sm border-0">
                  <div className="card-body">
                     <h5 className="card-title mb-3 fw-bold text-end"> 4. الشروط والأحكام (Terms and Conditions) ⚖️</h5>
                     <ul className="list-group list-group-flush text-end">
                        <li className="list-group-item">
                           موقعنا يعمل كوسيط لحجز   خدمات  الأشعة والخدمات  والخدمات  الطبية من خلال شركاء موثوقين (معامل – مراكز – مستشفيات).
                        </li>
                        <li className="list-group-item">
                           جميع الحجوزات تتم وفق مواعيد متاحة ومحددة من قبل مقدمي الخدمة.
                        </li>
                        <li className="list-group-item">
                           العميل مسؤول عن صحة البيانات الطبية المُدخلة، وأي خطأ فيها قد يؤدي إلى رفض الطلب.
                        </li>
                        <li className="list-group-item">
                           خطاب التحويل يُستخدم مرة واحدة فقط، ولا يُعاد إصداره بعد الاستخدام.
                        </li>
                        <li className="list-group-item">
                           يحتفظ الموقع بحقه في تعديل الأسعار أو السياسات في أي وقت.
                        </li>
                     </ul>
                  </div>
               </div>
            </div>



         </div>
      </Fragment>
   )
}
